// ============================================================
// logout.js — Bouton de déconnexion
// Reçoit onLogout en prop (fourni par loginApp.js via App.js).
// Plus de dépendance au hook useAuth0.
// ============================================================

import React from 'react';
import { Button } from 'react-bootstrap';
import { BoxArrowRight } from 'react-bootstrap-icons';

const Logout = ({ onLogout }) => {
    return (
        <Button
            className="navbar-logout-btn"
            style={{ marginBottom: "5px", marginLeft: "12px", backgroundColor: "green", borderColor: "green", color: "white", padding: "6px 14px", whiteSpace: "nowrap", fontSize: "0.95rem", display: "inline-flex", alignItems: "center", gap: "4px" }}
            onClick={onLogout}
        >
            Déconnexion <BoxArrowRight size={18} strokeWidth={2.5} />
        </Button>
    );
};

export default Logout;
